export {default} from "./ViewAllLink";
